/**
 * This rescales the telemetry values which were expected to be in KW or KWh but are reported in
 * W or Wh instead. This is a quick fix and should be handled more thoughtfullly in the future.
 */
export function scaleToKilo(value?: number | undefined | null): number | null {
    return typeof value === 'number' ? value / 1000 : null;
}
